


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class SearchResultsCategory extends Vue {
	@Prop({ required: true })
	public header!: string;

	@Prop()
	public results?: any[];

	@Prop({ required: true })
	public showMoreRoute!: { name: string; params?: any; query?: any };

	@Prop({ default: false })
	public inline!: boolean;

	public goToMore(): void {
		this.$router.push(this.showMoreRoute);
	}

	public isLimited<T>(): boolean {
		return (this.results ?? []).length >= 10;
	}
}
